import { heroArrowPath, heroArrowRightStartOnRectangle, heroBriefcase, heroChevronLeft, heroChevronRight, heroClipboardDocument, heroCog8Tooth, heroLink, heroListBullet, heroUsers } from "@ng-icons/heroicons/outline";
import { heroBuildingOffice2Solid, heroChartBarSolid, heroClipboardDocumentListSolid, heroComputerDesktopSolid, heroDocumentCurrencyDollarSolid, heroDocumentPlusSolid, heroDocumentTextSolid, heroFunnelSolid, heroRectangleStackSolid, heroShieldCheckSolid, heroUserGroupSolid, heroSquare3Stack3dSolid } from "@ng-icons/heroicons/solid";
import { toSeguradoOutline } from "../sidebar/sidebar.icons";

export const menuMobileIcons = {
  heroUsers,
  heroClipboardDocument,
  heroListBullet,
  heroArrowPath,
  heroComputerDesktopSolid,
  heroCog8Tooth,
  heroBriefcase,
  heroArrowRightStartOnRectangle,
  heroUserGroupSolid,
  heroBuildingOffice2Solid,
  heroClipboardDocumentListSolid,
  heroChevronLeft,
  heroChevronRight,
  heroFunnelSolid,
  heroChartBarSolid,
  heroLink,
  heroDocumentTextSolid,
  heroShieldCheckSolid,
  heroDocumentCurrencyDollarSolid,
  heroRectangleStackSolid,
  heroDocumentPlusSolid,
  heroSquare3Stack3dSolid,
  toSeguradoOutline
}